(() => {
  let customerPrivacy;
  let pendingConsent;

  const submitConsent = consent => {
    pendingConsent = consent;

    if (!customerPrivacy) return;

    const nextConsent = pendingConsent;
    pendingConsent = undefined;
    customerPrivacy.setTrackingConsent(nextConsent, () => {});
  };

  const handleConsent = event => {
    const detail = event.detail || {};

    submitConsent({
      analytics: detail.analytics_storage === 'granted',
      marketing: detail.ad_storage === 'granted',
      preferences: detail.functionality_storage === 'granted'
    });
  };

  window.addEventListener('ConsentAccepted', handleConsent);
  window.addEventListener('ConsentDeclined', handleConsent);

  const loadCustomerPrivacy = attempt => {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      if (attempt < 20) {
        window.setTimeout(() => loadCustomerPrivacy(attempt + 1), 100);
      }
      return;
    }

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      error => {
        if (error || !window.Shopify.customerPrivacy) return;

        customerPrivacy = window.Shopify.customerPrivacy;

        if (pendingConsent) submitConsent(pendingConsent);
      }
    );
  };

  loadCustomerPrivacy(0);
})();
